import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, Linking,
	Dimensions, Image, AsyncStorage } from "react-native";
import { color } from "../config/color"
import store from "../config/config.json"
import Main from "../widgets/Main";
import GlowOpacity from "../widgets/GlowOpacity";
import MainComponent from "../utilities/MainComponent";
import * as Font from 'expo-font';
import i18n from 'i18n-js';
import AppContext from "../utilities/AppContext"
import { payment } from "../config/payment"
import Axios from 'axios'
import * as firebase from "firebase";

export default class SuccessScreen extends MainComponent {	
	
	state = {
		store : {},
		isLoading: false,
		orderData: undefined,
		showFullMode 	: true,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
		
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
		this.state.totalPrice = 0

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()

		let params = this.props.navigation.state.params
		if(params.paymentId != undefined){
			this.finalizePayment(params.paymentId)
		}
		else if (params.orderId != undefined)
		{
			firebase.database().ref('storeOrders/' + store.storeId + "/" + params.orderId).once("value", function(snapshot)		
			{			
				var orderData = snapshot.val()
				if(orderData != undefined)
				{					
					this.callPixelEvent("Purchase", {currency: orderData.currency, value: orderData.totalPrice})
					this.setState({isLoading: false, orderData: orderData})			
				}
				else{
					this.setState({isLoading: false, showError: true, errorMessage: "Order with these details not found"})
				}
			}
			.bind(this), function(error) { 
				console.log(error)
				this.setState({isLoading: false, showError: true, errorMessage: "An unkown error has occurred"})
			});
		}else
			this.props.navigation.navigate("menu")
	}

	async finalizePayment(paymentId)
	{
		this.setState({isLoading: true})
		var that = this
		let options = {
			url: payment.finalUrl,
			method: 'POST',
			data: {
				storeId: store.storeId,
				paymentId: paymentId
			}
		};

		Axios(options)
			.then(response => 
			{
				if(response.status == 200)
				{
					if(response.data.error == false)	
					{		
						this.callPixelEvent("Purchase", {currency: response.data.data.currency, value: response.data.data.totalPrice})
						this.setState({orderData : response.data.data, isLoading: false})
					}
					else
						this.setState({isLoading: false, showError: true})	
				}
				else
				{
					return Promise.reject()
				}
		}).catch(exception => {
			console.log(exception)
			this.setState({isLoading: false, showError: true})
		});	
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);
		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
			{
				value = {}
			}
			else
			{
				this.setState({store: JSON.parse(value)})
			}

			await AsyncStorage.removeItem(store.promo)
			await AsyncStorage.removeItem(store.delivery)
			await AsyncStorage.removeItem(store.key)

        } catch (error) {
            ///console.log(error)
        }
	}
	
	onSubmit = async () => {
		try {
			this.props.navigation.navigate('menu')
		} catch (error) {
			console.log(error)
		}
	}

	callOnPhone = async () => {
		var str = this.state.store.phone;
		var phoneString = str.replace(/-/g, "");
		const url = `tel:${phoneString}`;

		Linking.canOpenURL(url)
			.then((supported) => {
				if (supported) {
					return Linking.openURL(url)
						.catch(() => null);
				}
			});
	}

	openReceipt = async () => {
		this.context.receiptData = {
			data: this.state.orderData,
			showReceipt: true
		}
		this.props.navigation.navigate('receipt')
	}
	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){
		var height = 3
		var orderId = ""
		var estimatedText = "--"

		if(this.state.orderData != undefined)
		{
		 	orderId = this.state.orderData.orderId.slice(0, 4) + "-" + this.state.orderData.orderId.slice(4);
			if(this.state.orderData.deliveryData.area != undefined)
				estimatedText = this.state.orderData.deliveryData.area.estimatedTime	 
		}

		return (
			<View style={styles.container}>
				
				{orderId == "" && (
					<View style={{flex: 1, justifyContent: "center", alignItems: "center", alignItems: "center"}}>
							<ActivityIndicator size="small" color={store.primaryColor} /> 
					</View>
				)}
				{orderId != "" && (
				<View>
					<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
					
								<div style={{width: 155, height: 155}}>

								<svg xmlns="http://www.w3.org/2000/svg" width="169" height="155" viewBox="0 0 521 479">
								<defs>
									<clipPath id="clip-PymentDone">
									<rect width="521" height="479"/>
									</clipPath>
								</defs>
								<g id="PymentDone" clipPath="url(#clip-PymentDone)">
									<g id="good" transform="translate(49.766 26)">
									<path id="Path_91" data-name="Path 91" d="M433.1,221.271,326.741,291.7a36.217,36.217,0,0,1-25.727,5.576,36.338,36.338,0,0,0-25.788,5.563l-14.233,9.431L181.285,194.777l19.555-84.484a88.145,88.145,0,0,0-12.385-68.569A21.082,21.082,0,0,1,220.7,14.947l12.668,12.271a135.438,135.438,0,0,1,32.685,50.1l6.871,18.495,70.742-46.739a24.123,24.123,0,0,1,33.8,7.362c6.959,11.149,3.387,25.88-7.577,33.138a.265.265,0,0,0-.1.335.269.269,0,0,0,.345.133,23.9,23.9,0,0,1,8.621-1.6,24.111,24.111,0,0,1,23.684,28.8,24.656,24.656,0,0,1-10.114,15.277.518.518,0,0,0-.133.716.018.018,0,0,0,.02.016.507.507,0,0,0,.68.133,24.728,24.728,0,0,1,5.853-.69,25.427,25.427,0,0,1,13.605,3.943,23.7,23.7,0,0,1,7.037,6.9,24.115,24.115,0,0,1-6.8,33.427c-.273.185-.547.371-.82.547a.378.378,0,0,0-.124.472.228.228,0,0,0,.088.088.388.388,0,0,0,.478-.02,23.62,23.62,0,0,1,20.466,2.635,24.491,24.491,0,0,1,7.2,7.144A24.13,24.13,0,0,1,433.1,221.271Zm0,0" transform="translate(-30.222 -1.504)" fill="none"/>
									<path id="Exclusion_4" data-name="Exclusion 4" d="M-5039.5,202.525a186.127,186.127,0,0,1-41.712-24.034,187.391,187.391,0,0,1-33.985-33.636,186.181,186.181,0,0,1-24.453-41.435,185.112,185.112,0,0,1-13.118-47.431l75.173-49.78,102.872,153.419-64.776,42.9Z" transform="translate(5161.647 203.145)" fill={store.primaryColor}/>
									<path id="Path_97" data-name="Path 97" d="M415.191,182.673a30.542,30.542,0,0,0-18.914-13.02,30.717,30.717,0,0,0-20.486-44.28,30.791,30.791,0,0,0-1.591-31.29,30.517,30.517,0,0,0-18.914-13.019,30.749,30.749,0,0,0-44.2-39.937L280.471,61.4a191.3,191.3,0,0,0-51.688-17.493,142.129,142.129,0,0,0-19.724-23.863L196.394,7.772A27.711,27.711,0,0,0,154,42.969q.5.756.979,1.519a192.884,192.884,0,1,0,219.854,254.56,6.629,6.629,0,1,0-12.47-4.5A179.858,179.858,0,0,1,136.658,404.011L190.6,368.287s.007,0,.01-.007,0,0,.007-.007l44.833-29.689h0a18.085,18.085,0,0,0,5.095-25.06l-.592-.9,8.709-5.768a29.534,29.534,0,0,1,21.045-4.548,42.75,42.75,0,0,0,30.467-6.588l72.235-47.836a180,180,0,0,1-2.443,18.622,6.628,6.628,0,0,0,5.309,7.73,6.469,6.469,0,0,0,1.217.114,6.632,6.632,0,0,0,6.51-5.423,193.907,193.907,0,0,0,3.169-30.154l20.356-13.481a30.755,30.755,0,0,0,8.66-42.621ZM267.6,69.925,247.34,83.342,243.352,72.6a141.889,141.889,0,0,0-5.69-13.179A177.976,177.976,0,0,1,267.6,69.925ZM57.643,115.89A179.634,179.634,0,0,1,161.324,56.776a81.91,81.91,0,0,1,4.132,49.609l-16.165,69.837a18.048,18.048,0,0,0-23.14-2.7l-45.789,30.32s0,0-.007,0a0,0,0,0,0,0,0L14.31,247.585c-.361-4.659-.55-9.353-.55-14.044A179.564,179.564,0,0,1,57.643,115.89ZM230.2,324.466a4.8,4.8,0,0,1-2.069,3.065h0l-39.377,26.075L115.671,244.612A6.63,6.63,0,0,0,104.659,252L177.7,360.928l-56.213,37.227A180.172,180.172,0,0,1,16.044,262.088l66.119-43.642L89.772,229.8a6.631,6.631,0,0,0,11.015-7.385l-7.557-11.273,40.243-26.563a4.824,4.824,0,0,1,6.682,1.363L229.5,320.848A4.78,4.78,0,0,1,230.2,324.466Zm176.5-121.33a17.374,17.374,0,0,1-7.486,11.1l-23.27,15.411a.143.143,0,0,1-.023.013l-83.059,55.006a29.518,29.518,0,0,1-21.045,4.548,42.773,42.773,0,0,0-30.467,6.588l-8.709,5.768-73.172-110.49,18.914-81.705A95.262,95.262,0,0,0,171.4,46.844a6.5,6.5,0,0,0-.28-.589,93.788,93.788,0,0,0-6.067-10.609,14.452,14.452,0,0,1,22.109-18.355L199.83,29.569a129.544,129.544,0,0,1,31.088,47.644l6.9,18.579c.013.036.026.065.039.1s.036.088.052.13c.049.114.094.218.143.306a6.542,6.542,0,0,0,.455.82,6.626,6.626,0,0,0,9.187,1.867l70.716-46.827a17.493,17.493,0,0,1,19.318,29.169l-6.139,4.067a.01.01,0,0,0-.007,0l-13.693,9.07a.5.5,0,0,1-.052.036c-.078.055-.153.107-.215.159a6.626,6.626,0,0,0,7.59,10.859l13.7-9.077a17.494,17.494,0,0,1,19.308,29.178l-19.838,13.14a6.629,6.629,0,1,0,7.32,11.055l3.071-2.033,10.625-7.037a17.494,17.494,0,0,1,19.318,29.172l-9.909,6.562c-.052.033-.1.068-.156.1l-9.773,6.471a6.63,6.63,0,1,0,7.32,11.058l3.071-2.033a0,0,0,0,1,0,0l10.625-7.034a17.488,17.488,0,0,1,26.8,18.065Zm0,0"/>
									</g>
								</g>
								</svg>
								</div>


								<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:18}}>{i18n.t("thankYou")}</Text>		
								<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:14}}>{i18n.t("orderPlaced")}</Text>		
					</View>

					<View style={{marginTop: 15, height: 34, alignItems: "center", alignContent: "center", justifyContent: "center"}}>
							<View style={{justifyContent: "center", width: 165, height: 34, alignItems: "center", alignContent: "center", flexDirection: 'row',
										borderColor: color.detailsColor, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor: color.bigSeparator}}
							>
									<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 12, textAlign: "center"}}>{i18n.t("orderCode")}</Text>
									<Text style={{marginLeft: 8, fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 12, textAlign: "center"}}>{orderId}</Text>
							</View>								
					</View>

					<View style={{width:"100%", height:55, justifyContent: "center", alignContent: "center"}} >
						<View style={{marginLeft: 15, marginRight: 15, flexDirection: "row", justifyContent: "center"}}>
							<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:16, textAlign: "center", marginTop: 5}}>{i18n.t("estimatedTime")}</Text>	
							<Text style={{marginLeft: "auto", fontFamily: 'main-regular',fontSize:16, color: 'black', marginRight: 15, textAlign: "center"}}>{estimatedText}</Text>		
						</View>
					</View>
									

					<View style={{height: height, marginTop: 5, flexDirection: "row"}}>

						<View style={{height: height, width: 15}}/>
									
						<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
						<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:color.bigSeparator}}/>
						<View style={{height: height, flex: 1, borderRadius: 1, backgroundColor:color.bigSeparator}}/>
						<View style={{height: height, width: 15}}/>

					</View>

					<Text style={{margin:15, fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14}}>{i18n.t("confirmingOrder")}</Text>

					<GlowOpacity 
						glowColor={this.state.store.primaryColor}
						style={{ marginTop: 10, marginLeft: 15, marginRight: 15, borderColor: color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor:'white'}}
						onPress={() => { this.openReceipt() }}
					>
							<View style={{justifyContent: "center", height: 34, alignItems: "center", alignContent: "center"}}>
								<Text style={{ fontFamily: 'main-bold', color: 'black', fontSize: 12, textAlign: "center"}}>{i18n.t("viewReceipt")}</Text>
							</View>								
					</GlowOpacity>

					<GlowOpacity 
						glowColor={this.state.store.primaryColor}
						style={{marginLeft: 15, marginRight: 15, marginTop: 10, borderColor: color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor:'white'}}
						onPress={() => { this.callOnPhone() }}
					>
						<View style={{justifyContent: "center", height: 34, alignItems: "center", alignContent: "center"}}>
							<Text style={{ fontFamily: 'main-bold', color: 'black', fontSize: 12, textAlign: "center"}}>{i18n.t("getHelp")}</Text>
						</View>								
					</GlowOpacity>
					
					<View style={{height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.onSubmit() }}
								>
						<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
							<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t("startOver")}</Text>		
						</View>

					</TouchableOpacity>

				</View>
				</View>
				)}
			</View>
		)
	}

	render() {
		var that = this
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>						
					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

								{that.renderDetails()}

							</View>

							<Main {...this.state} changeMenu={this.changeMenu} />

						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && (
						<View style={styles.container}>						
													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
								{that.renderDetails()}
							</View>

						</View>
					)}
					
				</View>
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});